/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmSkillsUpdate } from "../../funcs/llmSkillsUpdate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.UpdateSkillRequest$inboundSchema,
};

export const tool$llmSkillsUpdate: ToolDefinition<typeof args> = {
  name: "llm-skills-update",
  description: `Update skill

Update the default version pointer for a skill.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmSkillsUpdate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
